import {socket} from 'context/socket';

var IDLE_TIMER = null;
var IS_IDLE_STATE = true;

export const trackUserIdleState = async (connectedUser) => {
  await clearTimeout(IDLE_TIMER)

  if(IS_IDLE_STATE) {
    IS_IDLE_STATE = false;
    await userIdleStateEmiter(connectedUser);
  }

  IDLE_TIMER = await setTimeout(async()=>{
    IS_IDLE_STATE = true;
    await userIdleStateEmiter(connectedUser);
     //console.log("IDLE_TIMER: ", IS_IDLE_STATE)
  },300000)
}

export const userIdleStateEmiter = (connectedUser) => {
  let _userId = connectedUser && connectedUser.id
  if(_userId && _userId !== undefined) {
    let _data = {}
    _data.userId = _userId
    _data.isIdle = IS_IDLE_STATE
    _data.authToken = connectedUser.authToken
     //console.log("userIdleStateEmiter Emit value: ", _data)
    socket.emit("track_user_idle", _data)
  }
}

export const checkOtherUserStatus = async (connectedUser) => {
  // console.log("checkOtherUserStatus => hitted")
  let _userId = connectedUser.id
  if(_userId && _userId !== undefined) {
    let _data = {}
      _data.userId = _userId
      _data.authToken = connectedUser.authToken
    await socket.emit("check_other_user_status", _data);
    await socket.emit('check_users_activity')
		await socket.emit('check_users_disconnected')

    setTimeout(async () => {
      checkOtherUserStatus(connectedUser);
    }, 50000);
  }
}

export const sendSignalForUserLastActivity = async (connectedUser) => {
    //console.log("sendSignalForUserLastActivity",connectedUser)
  if(!IS_IDLE_STATE) {
    let _data = {}
    let _userId = connectedUser.id
      _data.userId = _userId
      _data.authToken = connectedUser.authToken
    socket.emit("user_last_activity", _data)
    setTimeout(()=>{sendSignalForUserLastActivity(connectedUser);}, 60000)
  }
}